import React from 'react';
import { FadeIn } from './components/FadeIn';
export function App() {
  return <main className="min-h-screen bg-neutral-50 flex flex-col justify-center" data-id="element-0">
      {/* Section 2: Guide Download */}
      <section className="py-[50px] md:py-[80px] px-6 bg-brand-darkGray border-y border-brand-gold/20 w-full" data-id="element-1">
        <div className="max-w-[900px] mx-auto text-center" data-id="element-2">
          <FadeIn data-id="element-3">
            <img src="https://cdn.magicpatterns.com/uploads/w8MXs5PEYjgLoK9b6Ekjje/heylloyd-image-1775232597530.png" alt="Guía Gratuita de Protección Familiar - Los Guardianes Funerarios" className="mx-auto mb-10 w-[260px] md:w-[320px] rounded-lg shadow-[0_8px_30px_rgba(245,166,35,0.3)] border border-brand-gold/30" data-id="element-4" />

            <h2 className="text-[28px] md:text-[32px] font-bold text-brand-gold mb-6" data-id="element-5">
              Mientras Esperas, Descarga Tu Guía Gratuita
            </h2>

            <p className="text-[18px] md:text-[20px] text-white mb-10 max-w-2xl mx-auto" data-id="element-6">
              La Guía Paso a Paso Que Toda Familia Hispana Necesita Para el
              Momento Más Difícil.
            </p>

            <a href="https://gamma.app/docs/Programa-Funeral-Advantage-Los-Guardianes-Funerarios-dey0gxgnqcz0q3e" target="_blank" rel="noopener noreferrer" className="inline-block w-full sm:w-auto bg-brand-gold hover:bg-[#FFB733] text-black font-bold text-[18px] md:text-[20px] py-4 px-10 rounded-[10px] shadow-[0_4px_15px_rgba(245,166,35,0.4)] hover:shadow-[0_6px_20px_rgba(245,166,35,0.6)] transition-all duration-300 hover:-translate-y-0.5" data-id="element-7">
              ⬇️ SÍ, QUIERO DESCARGAR MI GUÍA GRATUITA AHORA
            </a>
          </FadeIn>
        </div>
      </section>
    </main>;
}